module.exports = __webpack_public_path__ + "static/media/JO.e292fe22.png";